// extracted by mini-css-extract-plugin
export var change = "_3q-1";
export var changeList = "_3q-0";
export var changePath = "_3q-2";
export var diffArrow = "_3q-5";
export var diffRow = "_3q-3";
export var diffValue = "_3q-4";
export var error = "_3q-8";
export var notice = "_3q-9";
export var result = "_3q-6";
export var success = "_3q-7";